<div class="row row-page-title page-row">

  <div class="title-page-col">

    <h1 class="page-title">
      Nova Empresa
    </h1>

  </div>

</div>

<p class="page-subtitle sub-alone">
  Empresa
</p>

<form [formGroup]="companyUserForm" (ngSubmit)="onSubmit()" style="text-align: unset">

  <div formGroupName="company" *ngIf="companyForm" class="row row-info-input page-row with-title">

    <div class="col-info-input" style="width: 45%;">

      <p class="page-subtitle">
        Nome
      </p>

      <input
        type="text"
        [ngClass]="{
          'border-red':
            (!companyForm.controls.name.valid) &&
            (companyForm.controls['name'].touched)
        }"
        placeholder="Nome Empresa"
        class="search-input info-input"
        formControlName="name"
      >

      <app-form-errors
        [errorMsg]="'Campo Obrigátorio!'"
        *ngIf="
          !companyForm.controls.name.valid &&
          companyForm.controls['name'].touched
        "
      ></app-form-errors>

    </div>

    <div class="col-info-input" style="width: 47.3%">

      <p class="page-subtitle">
        Data Limite para Acesso
      </p>

      <input
        type="date"
        [ngClass]="{
          'border-red':
            (!companyForm.controls.expirationDate.valid) &&
            (companyForm.controls['expirationDate'].touched)
        }"
        placeholder="Data Limite Acesso"
        class="search-input info-input"
        formControlName="expirationDate"
      >

      <app-form-errors
        [errorMsg]="'Campo Obrigátorio!'"
        *ngIf="
          !companyUserForm.controls.company.controls.expirationDate.valid &&
          companyForm.controls['expirationDate'].touched
        "
      ></app-form-errors>

    </div>

  </div>

  <p class="page-subtitle sub-alone">
    Usuário
  </p>

  <div formGroupName="user" *ngIf="userForm" class="row row-info-input page-row with-title">

    <div class="col-4">

      <p class="page-subtitle">
        Nome do Usuário
      </p>

      <input
        type="text"
        [ngClass]="{
          'border-red':
            (!userForm.controls.username.valid) &&
            (userForm.controls['username'].touched)
        }"
        placeholder="Nome Usuário"
        class="search-input info-input"
        formControlName="username"
      >

      <app-form-errors
        [errorMsg]="'Campo Obrigátorio!'"
        *ngIf="
          !userForm.controls.username.valid &&
          userForm.controls['username'].touched
        "
      ></app-form-errors>

    </div>

    <div class="col-4">

      <p class="page-subtitle">
        E-mail
      </p>

      <input
        type="email"
        [ngClass]="{
          'border-red':
            (!userForm.controls.email.valid) &&
            (userForm.controls.email.touched)
        }"
        placeholder="E-mail"
        class="search-input info-input"
        formControlName="email"
      >

      <app-form-errors
        [errorMsg]="'Endereço de Email inválido! Ex.: example1@example.com'"
        *ngIf="
          !userForm.controls.email.valid &&
          (userForm.controls['email'].touched)
        "
      ></app-form-errors>

    </div>

    <div class="col-4">

      <p class="page-subtitle">
        Senha
      </p>

      <input
        type="password"
        [ngClass]="{
          'border-red':
            (!userForm.controls.password.valid) &&
            (userForm.controls['password'].touched)
        }"
        placeholder="Senha"
        class="search-input info-input"
        formControlName="password"
      >

      <app-form-errors
        [errorMsg]="'Campo Obrigátorio!'"
        *ngIf="
          !userForm.controls.password.valid &&
          userForm.controls['password'].touched
        "
      ></app-form-errors>

    </div>

  </div>

  <div class="col-12 col-alone-btn">

    <button
      class="btn-principal"
      style="width: 122px"
      [disabled]="companyUserForm.invalid || submitMode"
    >
      Salvar
    </button>

  </div>

</form>
